var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"pd-VendorSide_GoogleStaticMap",attrs:{"border":"0","src":_vm.googleMapsSrc}})}
var staticRenderFns = []

export { render, staticRenderFns }